import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FiCode,
  FiLayout,
  FiServer,
  FiLink,
  FiZap,
  FiSearch,
  FiCloud,
} from "react-icons/fi";
import { services } from "../data/services";
import "./Services.css";

const iconMap = {
  code: FiCode,
  wordpress: FiLayout,
  server: FiServer,
  api: FiLink,
  speed: FiZap,
  seo: FiSearch,
  cloud: FiCloud,
};

const Services = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section id="services" className="services section" ref={ref}>
      <div className="container">
        <motion.div
          className="section__header"
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <span className="section__label">Services</span>
          <h2 className="section__title">What I Can Do For You</h2>
        </motion.div>

        <div className="services__grid">
          {services.map((service, i) => {
            const Icon = iconMap[service.icon] || FiCode;
            return (
              <motion.div
                key={service.id}
                className="service-card"
                initial={{ opacity: 0, y: 20 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.4, delay: i * 0.1 }}
              >
                <div className="service-card__icon">
                  <Icon size={24} />
                </div>
                <h3 className="service-card__title">{service.title}</h3>
                <p className="service-card__desc">{service.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
